<template>
  <div class="logo">
    <Vue3Lottie
      v-if="icon === 'logo'"
      ref="logo"
      :animationData="require('../../assets/lotties/logo.json')"
      :loop="false"
      :autoPlay="false"
      :speed="1"
      :pauseAnimation="true"
      :direction="'reverse'"
      v-on:mouseover="hoverLogo"
      v-on:mouseleave="leaveLogo"
    />

    <Vue3Lottie
      v-if="icon === 'explore'"
      ref="logo"
      :animationData="require('../../assets/lotties/explore.json')"
      :loop="false"
      :autoPlay="false"
      :speed="1"
      :pauseAnimation="true"
      :direction="'reverse'"
      v-on:mouseover="hoverLogo"
      v-on:mouseleave="leaveLogo"
    />

    <Vue3Lottie
      v-if="icon === 'about'"
      ref="logo"
      :animationData="require('../../assets/lotties/about.json')"
      :loop="false"
      :autoPlay="false"
      :speed="1"
      :pauseAnimation="true"
      :direction="'reverse'"
      v-on:mouseover="hoverLogo"
      v-on:mouseleave="leaveLogo"
    />

    <svg
      v-if="icon === 'rocket'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      :class="[customClass]"
    >
      <g class="cls-1">
        <g id="Rocket">
          <path
            class="cls-3"
            d="M197.51,127.74a10.75,10.75,0,0,0-2.62-.34H128.7l-23.28-23.28H55.65L80.36,127.4H68.94a10.46,10.46,0,0,0-10.43,10.43v24.34a10.2,10.2,0,0,0,.5,3.16,10.48,10.48,0,0,0,9.43,7.26H80.36L55.65,195.88h49.77L128.7,172.6h66.19a10.28,10.28,0,0,0,2.62-.34,97.83,97.83,0,0,0,29.24-9.56,71.31,71.31,0,0,0,17.6-12.7C228,133.69,205.15,128.92,197.51,127.74Zm-86,35.3A13.05,13.05,0,1,1,122,157.67,13,13,0,0,1,111.48,163Zm38.58,0a13,13,0,1,1,11.49-6.86A13,13,0,0,1,150.06,163Zm38.59,0a13.05,13.05,0,1,1,10.22-4.95A13,13,0,0,1,188.65,163Z"
          />
        </g>
        <g id="ShadowRocket">
          <path
            class="cls-4"
            d="M226.75,162.7a97.83,97.83,0,0,1-29.24,9.56,10.28,10.28,0,0,1-2.62.34H128.7l-23.28,23.28H55.65L80.36,172.6H68.44A10.48,10.48,0,0,1,59,165.33c3.15-.51,8.72-1.43,16.11-2.5s16.79-2.31,27.35-3.41A13,13,0,0,0,122,157.67c5.44-.41,11.08-.75,16.84-1a13,13,0,0,0,22.69-.48c5.24,0,10.52.11,15.8.33a13,13,0,0,0,21.52,1.58A232.6,232.6,0,0,1,226.75,162.7Z"
          />
        </g>
      </g>
    </svg>

    <Vue3Lottie
      v-if="icon === 'education'"
      ref="logo"
      :animationData="require('../../assets/lotties/education.json')"
      :loop="true"
      :autoPlay="true"
      :speed="1"
      :pauseAnimation="false"
    />

    <Vue3Lottie
      v-if="icon === 'work'"
      ref="logo"
      :animationData="require('../../assets/lotties/work.json')"
      :loop="true"
      :autoPlay="true"
      :speed="1"
      :pauseAnimation="false"
    />

    <Vue3Lottie
      v-if="icon === 'yt'"
      ref="logo"
      :animationData="require('../../assets/lotties/yt.json')"
      :loop="true"
      :autoPlay="true"
      :speed="1"
      :pauseAnimation="false"
    />

    <Vue3Lottie
      v-if="icon === 'synth'"
      ref="logo"
      :animationData="require('../../assets/lotties/synth.json')"
      :loop="true"
      :autoPlay="true"
      :speed="1"
      :pauseAnimation="false"
    />

    <Vue3Lottie
      v-if="icon === 'glasses'"
      ref="hoveredElement"
      :animationData="require('@/assets/lotties/glasses.json')"
      :loop="false"
      :autoPlay="false"
      :speed="1"
      :pauseAnimation="true"
      :direction="'reverse'"
    />

    <svg v-if="icon === 'de'" width="42.67" height="32" viewBox="0 0 640 480">
      <path fill="#ffce00" d="M0 320h640v160H0z" />
      <path d="M0 0h640v160H0z" />
      <path fill="#d00" d="M0 160h640v160H0z" />
    </svg>

    <svg v-if="icon === 'en'" width="42.67" height="32" viewBox="0 0 640 480">
      <g fill-rule="evenodd">
        <g stroke-width="1pt">
          <path
            fill="#bd3d44"
            d="M0 0h912v37H0zm0 73.9h912v37H0zm0 73.8h912v37H0zm0 73.8h912v37H0zm0 74h912v36.8H0zm0 73.7h912v37H0zM0 443h912v37H0z"
          />
          <path
            fill="#fff"
            d="M0 37h912v36.9H0zm0 73.8h912v36.9H0zm0 73.8h912v37H0zm0 73.9h912v37H0zm0 73.8h912v37H0zm0 73.8h912v37H0z"
          />
        </g>
        <path fill="#192f5d" d="M0 0h364.8v258.5H0z" />
        <path
          fill="#fff"
          d="m30.4 11l3.4 10.3h10.6l-8.6 6.3l3.3 10.3l-8.7-6.4l-8.6 6.3L25 27.6l-8.7-6.3h10.9zm60.8 0l3.3 10.3h10.8l-8.7 6.3l3.2 10.3l-8.6-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3h10.6zm60.8 0l3.3 10.3H166l-8.6 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.7-6.3h10.8zm60.8 0l3.3 10.3h10.8l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.4-10.2l-8.8-6.3h10.7zm60.8 0l3.3 10.3h10.7l-8.6 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3h10.7zm60.8 0l3.3 10.3h10.8l-8.8 6.3l3.4 10.3l-8.7-6.4l-8.7 6.3l3.4-10.2l-8.8-6.3h10.8zM60.8 37l3.3 10.2H75l-8.7 6.2l3.2 10.3l-8.5-6.3l-8.7 6.3l3.1-10.3l-8.4-6.2h10.7zm60.8 0l3.4 10.2h10.7l-8.8 6.2l3.4 10.3l-8.7-6.3l-8.7 6.3l3.3-10.3l-8.7-6.2h10.8zm60.8 0l3.3 10.2h10.8l-8.7 6.2l3.3 10.3l-8.7-6.3l-8.7 6.3l3.3-10.3l-8.6-6.2H179zm60.8 0l3.4 10.2h10.7l-8.8 6.2l3.4 10.3l-8.7-6.3l-8.6 6.3l3.2-10.3l-8.7-6.2H240zm60.8 0l3.3 10.2h10.8l-8.7 6.2l3.3 10.3l-8.7-6.3l-8.7 6.3l3.3-10.3l-8.6-6.2h10.7zM30.4 62.6L33.8 73h10.6l-8.6 6.3l3.3 10.2l-8.7-6.3l-8.6 6.3L25 79.3L16.3 73h10.9zm60.8 0L94.5 73h10.8l-8.7 6.3l3.2 10.2l-8.6-6.3l-8.7 6.3l3.3-10.3l-8.6-6.3h10.6zm60.8 0l3.3 10.3H166l-8.6 6.3l3.3 10.2l-8.7-6.3l-8.7 6.3l3.3-10.3l-8.7-6.3h10.8zm60.8 0l3.3 10.3h10.8l-8.7 6.3l3.3 10.2l-8.7-6.3l-8.7 6.3l3.4-10.3l-8.8-6.3h10.7zm60.8 0l3.3 10.3h10.7l-8.6 6.3l3.3 10.2l-8.7-6.3l-8.7 6.3l3.3-10.3l-8.6-6.3h10.7zm60.8 0l3.3 10.3h10.8l-8.8 6.3l3.4 10.2l-8.7-6.3l-8.7 6.3l3.4-10.3l-8.8-6.3h10.8zm-273.6 26l3.3 10.2H75l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3h10.7zm60.8 0l3.4 10.2h10.7l-8.8 6.3l3.4 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.7-6.3h10.8zm60.8 0l3.3 10.2h10.8l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3H179zm60.8 0l3.4 10.2h10.7l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.6 6.3l3.2-10.2l-8.7-6.3H240zm60.8 0l3.3 10.2h10.8l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3h10.7zM30.4 114.5l3.4 10.2h10.6l-8.6 6.3l3.3 10.3l-8.7-6.4l-8.6 6.3L25 131l-8.7-6.3h10.9zm60.8 0l3.3 10.2h10.8l-8.7 6.3l3.2 10.2l-8.6-6.3l-8.7 6.3l3.3-10.2l-8.6-6.3h10.6zm60.8 0l3.3 10.2H166l-8.6 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.7-6.3h10.8zm60.8 0l3.3 10.2h10.8l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.4-10.2l-8.8-6.3h10.7zm60.8 0l3.3 10.2h10.7L279 131l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3h10.7zm60.8 0l3.3 10.2h10.8l-8.8 6.3l3.4 10.3l-8.7-6.4l-8.7 6.3L329 131l-8.8-6.3H331zM60.8 140.3l3.3 10.3H75l-8.7 6.2l3.3 10.3l-8.7-6.4l-8.7 6.4l3.3-10.3l-8.6-6.3h10.7zm60.8 0l3.4 10.3h10.7l-8.8 6.2l3.4 10.3l-8.7-6.4l-8.7 6.4l3.3-10.3l-8.7-6.3h10.8zm60.8 0l3.3 10.3h10.8l-8.7 6.2l3.3 10.3l-8.7-6.4l-8.7 6.4l3.3-10.3l-8.6-6.3H179zm60.8 0l3.4 10.3h10.7l-8.7 6.2l3.3 10.3l-8.7-6.4l-8.6 6.4l3.2-10.3l-8.7-6.3H240zm60.8 0l3.3 10.3h10.8l-8.7 6.2l3.3 10.3l-8.7-6.4l-8.7 6.4l3.3-10.3l-8.6-6.3h10.7zM30.4 166.1l3.4 10.3h10.6l-8.6 6.3l3.3 10.1l-8.7-6.2l-8.6 6.2l3.2-10.2l-8.7-6.3h10.9zm60.8 0l3.3 10.3h10.8l-8.7 6.3l3.3 10.1l-8.7-6.2l-8.7 6.2l3.4-10.2l-8.7-6.3h10.6zm60.8 0l3.3 10.3H166l-8.6 6.3l3.3 10.1l-8.7-6.2l-8.7 6.2l3.3-10.2l-8.7-6.3h10.8zm60.8 0l3.3 10.3h10.8l-8.7 6.3l3.3 10.1l-8.7-6.2l-8.7 6.2l3.4-10.2l-8.8-6.3h10.7zm60.8 0l3.3 10.3h10.7l-8.6 6.3l3.3 10.1l-8.7-6.2l-8.7 6.2l3.3-10.2l-8.6-6.3h10.7zm60.8 0l3.3 10.3h10.8l-8.8 6.3l3.4 10.1l-8.7-6.2l-8.7 6.2l3.4-10.2l-8.8-6.3h10.8zM60.8 192l3.3 10.2H75l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3h10.7zm60.8 0l3.4 10.2h10.7l-8.8 6.3l3.4 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.7-6.3h10.8zm60.8 0l3.3 10.2h10.8l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3H179zm60.8 0l3.4 10.2h10.7l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.6 6.3l3.2-10.2l-8.7-6.3H240zm60.8 0l3.3 10.2h10.8l-8.7 6.3l3.3 10.3l-8.7-6.4l-8.7 6.3l3.3-10.2l-8.6-6.3h10.7zM30.4 217.9l3.4 10.2h10.6l-8.6 6.3l3.3 10.2l-8.7-6.3l-8.6 6.3l3.2-10.3l-8.7-6.3h10.9zm60.8 0l3.3 10.2h10.8l-8.7 6.3l3.3 10.2l-8.7-6.3l-8.7 6.3l3.4-10.3l-8.7-6.3h10.6zm60.8 0l3.3 10.2H166l-8.4 6.3l3.3 10.2l-8.7-6.3l-8.7 6.3l3.3-10.3l-8.7-6.3h10.8zm60.8 0l3.3 10.2h10.8l-8.7 6.3l3.3 10.2l-8.7-6.3l-8.7 6.3l3.4-10.3l-8.8-6.3h10.7zm60.8 0l3.3 10.2h10.7l-8.6 6.3l3.3 10.2l-8.7-6.3l-8.7 6.3l3.3-10.3l-8.6-6.3h10.7zm60.8 0l3.3 10.2h10.8l-8.8 6.3l3.4 10.2l-8.7-6.3l-8.7 6.3l3.4-10.3l-8.8-6.3h10.8z"
        />
      </g>
    </svg>

    <svg
      v-if="icon === 'adobecloud'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M343.06,193.94v9.45c-.09.51-.2,1-.27,1.53-.49,4.11-.81,8.24-1.49,12.32a100.39,100.39,0,0,1-14.2,37,105.92,105.92,0,0,1-44,39.52,104.21,104.21,0,0,1-34,9.93c-2.62.3-5.25.57-7.87.86H139.47a13.44,13.44,0,0,0-1.54-.28,87.41,87.41,0,0,1-29.55-7A89.73,89.73,0,0,1,62.6,254.11a84.23,84.23,0,0,1-8.46-27.88c-.29-2.37-.57-4.72-.86-7.08V210a11.14,11.14,0,0,0,.28-1.53,83.55,83.55,0,0,1,5.58-25.59q13-33.18,45.13-49.16a88.82,88.82,0,0,1,35.35-9,99.24,99.24,0,0,1,18.15.82,2.3,2.3,0,0,0,1.72-.55,107,107,0,0,1,29.67-21.3,104.42,104.42,0,0,1,34.11-10c2.82-.32,5.64-.58,8.46-.87h8.68c.57.09,1.14.19,1.71.26,4.3.5,8.63.81,12.88,1.52a102.56,102.56,0,0,1,37.11,14,105.61,105.61,0,0,1,40.06,43.69,100.82,100.82,0,0,1,10,33.67c.3,2.69.57,5.38.86,8.07M181,132.78c.18.23.21.34.29.37a115.61,115.61,0,0,1,17,10.2,1.75,1.75,0,0,0,1.59-.11,66,66,0,0,1,48-9.44,65,65,0,0,1,41,24.61c11.86,15.07,16.37,32.11,13.1,51.07-2.19,12.7-7.33,24.1-16.06,33.65C270,260.54,250,267.74,226.5,264.7a62.88,62.88,0,0,1-37.27-18.4c-13.26-13.27-26.6-26.45-39.9-39.69a10.81,10.81,0,0,0-6.29-3.49,10,10,0,0,0-10.44,5.63c-1.71,3.55-1.49,7.54,2.23,11.17,14.83,14.42,29.51,29,44.33,43.4a71.76,71.76,0,0,0,8.12,6.85c10.81,7.78,23,12.08,36.21,13.82a88.14,88.14,0,0,0,30.85-1.2A86.4,86.4,0,0,0,321,182.49a82.07,82.07,0,0,0-19.57-39.73C281.86,121,257.3,111.34,228.06,113.5a82.14,82.14,0,0,0-31.88,9.3,84,84,0,0,0-15.15,10m-7.14,151.65-1.21-1.12c-6.06-5.67-12.16-11.3-18.14-17a4.9,4.9,0,0,0-3.87-1.61c-6.06.14-12.14.16-18.11-1.17-29.71-6.66-47-38.68-36-66.84a51.29,51.29,0,0,1,56.14-31.57c10.56,1.88,19.85,6.3,27.46,14.09,9.28,9.5,18.85,18.73,28.24,28.13a8.48,8.48,0,0,0,7.55,2.7c3.82-.55,6.87-2.35,8.26-6.06a8.87,8.87,0,0,0-2.1-9.93c-9.85-9.89-19.47-20-29.72-29.49-19.89-18.37-43.33-23.84-69.26-16A69,69,0,0,0,75.81,230a70.07,70.07,0,0,0,68.71,54.63h27.75a13.1,13.1,0,0,0,1.64-.08"
      />
    </svg>

    <svg
      v-if="icon === 'ae'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M171,194.31c.95,2.76,1.8,5.42,2.44,7.65h-27c1.59-4.46,3.29-9.45,4.67-14.87,1.7-5.31,3.29-10.62,4.89-15.71a134.64,134.64,0,0,0,3.61-13.7h.21c.74,2.55,1.49,5.31,2.34,8.28s1.8,6.16,2.86,9.45,2,6.48,3.08,9.77S170.07,191.44,171,194.31Z"
      />
      <path
        class="cls-1"
        d="M287.2,74.43H122.61a45.08,45.08,0,0,0-45.13,45V277.77a45.08,45.08,0,0,0,45,45.13H287.2a45.08,45.08,0,0,0,45.12-45V119.56a45.08,45.08,0,0,0-45-45.13ZM212.44,249.21H190.25a1.6,1.6,0,0,1-1.7-1.17l-8.71-25.48v.53h-39.5l-8.07,25.06a1.85,1.85,0,0,1-2,1.48h-20c-1.17,0-1.49-.63-1.17-1.91l34.19-98c.32-1.06.64-2,1.07-3.29a38.09,38.09,0,0,0,.63-6.9,1.06,1.06,0,0,1,.85-1.17h27.5c.75,0,1.28.32,1.38.85l38.78,108.3C213.82,248.68,213.5,249.21,212.44,249.21Zm82.93-41.63c-.21,2-.32,3.51-.42,4.46a1.59,1.59,0,0,1-1.49,1.38c-.64,0-1.81.11-3.5.22a50.64,50.64,0,0,1-6.16.32c-2.45,0-5-.43-7.75-.43H242.38a23.48,23.48,0,0,0,3.3,9.45,16.78,16.78,0,0,0,7.75,6.37A33.12,33.12,0,0,0,267,232a64.58,64.58,0,0,0,11-1.17,40.55,40.55,0,0,0,9.45-2.44c.53-.43.85-.22.85.85v16.24a5.61,5.61,0,0,1-.21,1.28,2.38,2.38,0,0,1-.74.74,45.79,45.79,0,0,1-10.62,3.19,72.1,72.1,0,0,1-15,1.31c-8.07,0-14.87-1.27-20.39-3.72a35.8,35.8,0,0,1-13.38-10.08,39,39,0,0,1-7.32-13.91A55.11,55.11,0,0,1,221,191.9a43.45,43.45,0,0,1,8-14.55,38.61,38.61,0,0,1,12.84-10.09c5-2.44,10.94-3.29,17.74-3.29a38.68,38.68,0,0,1,16.46,3.29,29.39,29.39,0,0,1,11.15,8.5,38.79,38.79,0,0,1,6.37,12.1,41.87,41.87,0,0,1,2,13C295.58,203.34,295.48,205.57,295.37,207.58Zm-36.53-25.27a14.94,14.94,0,0,0-14.12,8.07,22.15,22.15,0,0,0-2.34,7.65h22.41c2.76,0,4.78,0,6-.11a5.11,5.11,0,0,0,2.44-.85V196a12.48,12.48,0,0,0-.63-3.93A14.05,14.05,0,0,0,258.84,182.31Z"
      />
    </svg>

    <svg
      v-if="icon === 'blender'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M275,243.75a44.6,44.6,0,0,1-60.92,0A35.7,35.7,0,0,1,203,216.15a36.31,36.31,0,0,1,13.19-25.72,44.72,44.72,0,0,1,56.73,0,36.38,36.38,0,0,1,13.19,25.71A35.77,35.77,0,0,1,275,243.75Z"
      />
      <path
        class="cls-1"
        d="M349.43,215.06a91.32,91.32,0,0,0-13-35.64,99.41,99.41,0,0,0-23.76-26.19h0L216.53,79.39c-.09-.06-.16-.14-.25-.19-6.31-4.85-16.92-4.83-23.85,0s-7.82,13-1.58,18.14h0L230.93,130l-122.23.13h-.16c-10.1,0-19.82,6.64-21.74,15-2,8.53,4.89,15.61,15.39,15.65h0l61.95-.12L53.58,245.57c-.14.1-.29.21-.42.32-10.43,8-13.8,21.26-7.24,29.66s20.84,8.56,31.38.05l60.34-49.38a95.23,95.23,0,0,0-.81,10.67,76.37,76.37,0,0,0,3.27,17.92,94.6,94.6,0,0,0,20.42,35.36,105.54,105.54,0,0,0,35.74,25.67,116.87,116.87,0,0,0,93.84-.16,106.21,106.21,0,0,0,35.71-25.77,95.36,95.36,0,0,0,20.42-35.43,88.9,88.9,0,0,0,3.2-39.42ZM194.5,259.37a57.91,57.91,0,0,1-13.29-20.8,54.09,54.09,0,0,1-3.05-23.25,55,55,0,0,1,6.66-21.88,60.42,60.42,0,0,1,14.79-17.58,70.27,70.27,0,0,1,87.13-.13,60,60,0,0,1,14.77,17.53,54.91,54.91,0,0,1,6.69,21.87,54,54,0,0,1-3.06,23.23,58.16,58.16,0,0,1-13.28,20.85c-12.43,12.67-29.83,19.85-48.67,19.89S206.93,272,194.5,259.37Z"
      />
    </svg>

    <svg
      v-if="icon === 'davinciresolve'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M200,74.11A125.89,125.89,0,1,0,325.89,200,125.89,125.89,0,0,0,200,74.11Zm0,11A114.94,114.94,0,1,1,85.06,200.05V200A114.85,114.85,0,0,1,199.82,85.06H200ZM200,107c-21.13,0-38.31,16.25-38.31,36.21,0,19.41,18,41.42,34.79,55.56a5.49,5.49,0,0,0,7,0c16.82-14.14,34.79-36.14,34.79-55.55C238.31,123.2,221.12,107,200,107Zm-52.38,93c-8.57.23-16.54,1.86-22.91,5.5a35.08,35.08,0,0,0-16.49,21.61,39.67,39.67,0,0,0,37.71,49.47,35.12,35.12,0,0,0,17.45-4.6c17-9.73,27.19-36.34,31.06-58a5.46,5.46,0,0,0-3.53-6.11C177.87,203.21,161.9,199.67,147.62,200Zm104.77,0c-14.28-.37-30.25,3.17-43.29,7.86a5.48,5.48,0,0,0-3.54,6.11c3.87,21.67,14.06,48.3,31.06,58a35,35,0,0,0,17.45,4.6,39.65,39.65,0,0,0,37.72-49.47,35.07,35.07,0,0,0-16.5-21.61c-6.37-3.59-14.29-5.22-22.9-5.49Z"
      />
    </svg>

    <svg
      v-if="icon === 'electron'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M165.84,128.29c-32.87-6-58.86.28-69.22,18.22-7.73,13.39-5.52,31.14,5.36,50.12a3.37,3.37,0,0,0,5.92-3.23l-.08-.13c-9.8-17.09-11.7-32.41-5.36-43.39,8.6-14.9,31.78-20.49,62.17-15a3.37,3.37,0,0,0,1.21-6.63Zm-46.77,91.4c13.29,14.61,30.56,28.31,50.26,39.68C217,286.9,267.78,294.26,292.8,277.2a3.38,3.38,0,0,0-3.71-5.64l-.09.07c-22.4,15.27-70.62,8.28-116.3-18.1-19.11-11-35.83-24.3-48.64-38.38a3.37,3.37,0,0,0-5,4.52h0Z"
      />
      <path
        class="cls-1"
        d="M284.81,215.59c21.53-25.43,29-51,18.71-68.91-7.61-13.17-23.69-20.13-45.06-20.41a3.37,3.37,0,1,0-.09,6.74c19.22.26,33.08,6.25,39.31,17,8.58,14.88,1.88,37.68-18,61.19a3.37,3.37,0,0,0,4.92,4.61c.06-.06.11-.13.17-.2ZM229.5,129.41c-19.47,4.17-40.18,12.33-60.08,23.81-49.22,28.42-81.33,70.33-76.87,100.72a3.37,3.37,0,0,0,6.68-.9V253c-4-27,26.48-66.71,73.58-93.9,19.29-11.14,39.35-19,58.11-23.06a3.37,3.37,0,0,0-1.31-6.61h-.1Z"
      />
      <path
        class="cls-1"
        d="M149.75,275c11.25,31.43,29.66,50.78,50.37,50.78,15.1,0,29.07-10.3,40-28.42a3.37,3.37,0,0,0-5.73-3.55h0v.08c-9.88,16.29-21.9,25.11-34.27,25.11-17.2,0-33.62-17.26-44-46.31a3.37,3.37,0,0,0-6.39,2.14.14.14,0,0,0,.05.13Zm102.79-6.14c5.83-18.62,9-40.1,9-62.48,0-55.84-19.55-104-47.39-116.35a3.37,3.37,0,0,0-2.73,6.16c24.83,11,43.38,56.72,43.38,110.19,0,21.71-3,42.51-8.65,60.46a3.37,3.37,0,0,0,6.41,2.11v-.09ZM316,265.55a16.14,16.14,0,1,0-16.14,16.14h0A16.13,16.13,0,0,0,316,265.56Zm-6.74,0a9.39,9.39,0,1,1-9.39-9.39,9.38,9.38,0,0,1,9.39,9.39v0ZM100.1,281.69A16.14,16.14,0,1,0,84,265.51v0A16.14,16.14,0,0,0,100.1,281.69Zm0-6.74a9.4,9.4,0,1,1,9.39-9.41h0a9.39,9.39,0,0,1-9.33,9.45h-.06Z"
      />
      <path
        class="cls-1"
        d="M200.12,106.49A16.14,16.14,0,1,0,184,90.33v0A16.14,16.14,0,0,0,200.12,106.49Zm0-6.74a9.4,9.4,0,1,1,9.39-9.41v0A9.41,9.41,0,0,1,200.12,99.75Zm2.46,118a11.67,11.67,0,1,1,8.95-13.87,11.67,11.67,0,0,1-8.95,13.87h0Z"
      />
    </svg>

    <svg
      v-if="icon === 'fl_studio'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <g id="first">
        <path
          class="cls-1"
          d="M148.65,124.63s-38.2,41.11-38.2,113.67c0,60.89,23.91,87.07,45.83,87.07,10.19,0,43.28-7.26,76.39-62.88,38.24-64.28,33.1-94.32,33.1-94.32Z"
        />
      </g>
      <g id="second">
        <path
          class="cls-2"
          d="M241.5,117.65a86.52,86.52,0,0,0-18.83,1.9c6.72-11,18.08-26.57,29.19-34a6,6,0,0,0,1.84-9.17,6,6,0,0,0-8.45-.76C232,84.44,219,102.2,211.5,114.89c-8.78-15.06-17.71-22.34-40.15-22.34-46.25,0-60.9,33.85-60.9,43.74,0,3.44,6.43,6.46,21.85,6.46s34.94-4.18,34.94-4.18c-2.94,5.65-4.37,12.55-4.37,20.92,0,20.91,13.11,37.65,30.58,37.65,26.21,0,39.31-29.28,39.31-29.28s30.58,33.46,41.37,33.46c10.28,0,15.42-14.83,15.42-34.61C289.55,151.87,277.47,117.65,241.5,117.65Z"
        />
        <path
          class="cls-2"
          d="M142.48,189.17a6,6,0,0,0-7.89,3.13c-6,19.81-8.08,38.69-6.19,56.1a6,6,0,0,0,5.93,5.33l.67,0a6,6,0,0,0,5.25-6.58c-1.72-15.81.22-33.09,5.75-51.36A6,6,0,0,0,142.48,189.17Z"
        />
      </g>
    </svg>

    <svg
      v-if="icon === 'nodejs'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M97.74,204.34a4.12,4.12,0,0,0-2.07-3.6L61.37,181a4.08,4.08,0,0,0-1.89-.54h-.36a4.21,4.21,0,0,0-1.89.54L22.92,200.74a4.19,4.19,0,0,0-2.07,3.61l.07,53.16A2,2,0,0,0,24,259.3l20.4-11.68a4.18,4.18,0,0,0,2.1-3.62V219.19a4.15,4.15,0,0,1,2.07-3.59l8.68-5a4.09,4.09,0,0,1,4.14,0l8.67,5a4.14,4.14,0,0,1,2.08,3.59V244a4.18,4.18,0,0,0,2.07,3.6l20.39,11.67a2,2,0,0,0,2.07,0,2.06,2.06,0,0,0,1-1.79ZM259.63,232a1,1,0,0,1-.52.9l-11.78,6.79a1,1,0,0,1-1,0l-11.78-6.79a1,1,0,0,1-.52-.9V218.4a1,1,0,0,1,.51-.9l11.78-6.8a1,1,0,0,1,1,0l11.79,6.8a1,1,0,0,1,.51.9Zm3.18-100.76a2.1,2.1,0,0,0-2.06,0,2.06,2.06,0,0,0-1,1.79v52.64a1.46,1.46,0,0,1-1.47,1.45,1.48,1.48,0,0,1-.71-.19L249,182a4.14,4.14,0,0,0-4.14,0l-34.32,19.8a4.13,4.13,0,0,0-2.07,3.58V245a4.15,4.15,0,0,0,2.07,3.59l34.32,19.82a4.21,4.21,0,0,0,4.15,0l34.31-19.83A4.18,4.18,0,0,0,285.4,245V146.28a4.15,4.15,0,0,0-2.13-3.62ZM377.09,218a4.12,4.12,0,0,0,2.06-3.58v-9.6a4.14,4.14,0,0,0-2.06-3.59L343,181.5a4.13,4.13,0,0,0-4.16,0l-34.31,19.8a4.15,4.15,0,0,0-2.07,3.59V244.5a4.15,4.15,0,0,0,2.09,3.6l34.09,19.43a4.15,4.15,0,0,0,4.07,0l20.62-11.46a2.07,2.07,0,0,0,0-3.61l-34.52-19.81a2.06,2.06,0,0,1-1-1.79v-12.4a2.06,2.06,0,0,1,1-1.79l10.74-6.2a2.05,2.05,0,0,1,2.06,0l10.75,6.2a2.06,2.06,0,0,1,1,1.79v9.77a2,2,0,0,0,3.08,1.8Z"
      />
      <path
        class="cls-1"
        d="M340.41,216.21a.8.8,0,0,1,.79,0l6.59,3.8a.81.81,0,0,1,.39.69v7.6a.81.81,0,0,1-.39.69l-6.59,3.8a.8.8,0,0,1-.79,0l-6.58-3.8a.79.79,0,0,1-.41-.69v-7.6a.78.78,0,0,1,.4-.69Z"
      />
      <path
        class="cls-2"
        d="M151,181.7l-34.12,19.69a4.13,4.13,0,0,0-2.07,3.57v39.42a4.13,4.13,0,0,0,2.07,3.57L151,267.66a4.15,4.15,0,0,0,4.12,0L189.27,248a4.12,4.12,0,0,0,2.06-3.57V205a4.12,4.12,0,0,0-2.06-3.57L155.15,181.7a4.17,4.17,0,0,0-4.13,0"
      />
    </svg>

    <svg
      v-if="icon === 'pureref'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M192.9,123a56.19,56.19,0,1,0,56.22,56.19A56.19,56.19,0,0,0,192.9,123Zm.07,95.55a39.43,39.43,0,1,1,39.45-39.43A39.43,39.43,0,0,1,193,218.55Z"
      />
      <path
        class="cls-1"
        d="M275.68,243.24s22.22-23.46,22.22-64.66S266,74.36,193.62,74.36,87.9,134.42,87.9,181.73s.39,143.52.39,143.52h61.54V274.39a103.9,103.9,0,0,0,43.4,9.85c24.42,0,32-5.52,32-5.52l39.59,46.92,47.33-40.35Zm-80.35,26.28c-42.83,0-60.09-20.76-60.09-20.76v61H102.49s.14-79.51.14-132.87,46.19-88.19,90.6-88.19,90.34,35.68,90.34,89.77-45.41,91-88.24,91Z"
      />
    </svg>

    <svg
      v-if="icon === 'python'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        id="path8615"
        class="cls-1"
        d="M199.09,75.48c-63.8,0-59.82,27.67-59.82,27.67l.07,28.67h60.89v8.61H115.16s-40.83-4.63-40.83,59.75S110,262.27,110,262.27h21.26V232.4s-1.14-35.64,35.07-35.64h60.39s33.93.55,33.93-32.79V108.84S265.77,75.48,199.09,75.48ZM165.52,94.76a10.94,10.94,0,1,1-.12,0Z"
      />
      <path
        id="path8620"
        class="cls-1"
        d="M200.91,325.52c63.8,0,59.82-27.67,59.82-27.67l-.07-28.67H199.77v-8.61h85.07s40.83,4.63,40.83-59.75S290,138.73,290,138.73H268.77V168.6s1.14,35.64-35.07,35.64H173.31s-33.93-.55-33.93,32.79v55.13S134.23,325.52,200.91,325.52Zm33.57-19.28a11,11,0,1,1,11-11h0a10.94,10.94,0,0,1-10.88,11Z"
      />
    </svg>

    <svg
      v-if="icon === 'tauri'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <g>
        <path
          class="cls-1"
          d="M220.58,189.47a24.38,24.38,0,1,0-24.38-24.38A24.37,24.37,0,0,0,220.58,189.47Z"
        />
        <circle class="cls-2" cx="179.58" cy="234.91" r="24.38" />
        <path
          class="cls-1"
          d="M312.62,151.13a93.1,93.1,0,0,0-180.9-13.79A108.49,108.49,0,0,1,167.42,127q1.41-2,3-3.82A65.41,65.41,0,1,1,242.1,226.87a66.63,66.63,0,0,1,.49,8,65.21,65.21,0,0,1-3.6,21.43,93.08,93.08,0,0,0,73.63-105.21Z"
        />
        <path
          class="cls-1"
          d="M229.62,276.85a65.42,65.42,0,1,1-72-103.62,65.54,65.54,0,0,1,3.63-29.62c-.89.17-1.78.39-2.67.59v0c-.33.07-.65.16-1,.24l-1.31.33c-.92.23-1.83.48-2.74.75l-1.17.33q-3.84,1.17-7.55,2.65l-1.13.47c-.88.37-1.74.74-2.61,1.13-.41.19-.82.37-1.23.57-.88.41-1.75.84-2.62,1.28l-1,.51c-1.15.6-2.29,1.22-3.42,1.87h0c-1.33.78-2.65,1.58-4,2.42A93.09,93.09,0,1,0,268.3,262.57,108.27,108.27,0,0,1,232.59,273Q231.18,275,229.62,276.85Z"
        />
      </g>
    </svg>

    <svg
      v-if="icon === 'unrealengine'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M200.15,79.84a117.63,117.63,0,0,1,84.3,35.25,121,121,0,0,1,0,170.12A118.44,118.44,0,0,1,117,286.32l-1.11-1.11a121,121,0,0,1,0-170.12,117.41,117.41,0,0,1,84.31-35.25m0-5.55c-69,0-124.81,56.26-124.81,125.71S131.15,325.71,200,325.71,324.66,269.45,324.66,200,269,74.29,200.15,74.29"
      />
      <path
        class="cls-1"
        d="M254.75,237.35c-4.5,0-6.3-2.7-6.3-2.7-.3-1.2-.6-19.05-.75-36.75-.15-18.45,0-36.75.9-36.9,5.25-9.75,21.75-29.4,21.75-29.4-30.9,6.15-47.7,26.4-47.7,26.4-5-3.9-15.15-3.3-15.15-3.3,4.8,2.55,9.45,10.2,9.45,16.5v62.1s-10.35,9.15-18.3,9.15a11.37,11.37,0,0,1-9.3-4.65,14,14,0,0,1-1.5-2.7V158.45a6.69,6.69,0,0,1-3.75,1.35c-1.65,0-3.45-.9-4.65-3.3-.9-1.95-1.5-4.65-1.5-8.85C178,133.55,194,124.1,194,124.1c-20.25,5.4-39.15,15.9-64.2,44.7s-20.26,52.5-20.26,52.5,6.75-16.5,23.41-33.75c8-8.1,13.8-10.8,17.85-11a6.21,6.21,0,0,1,6.59,5.81c0,.16,0,.33,0,.49V241.2c0,5.7-3.75,7.05-7.2,6.9a17.55,17.55,0,0,1-5.55-1c17.1,24.75,57.9,28.35,57.9,28.35l18-19.2.45.3,16.5,13.95c30-17.85,44.55-51,44.55-51-13.65,14.55-22.2,17.85-27.3,17.85"
      />
    </svg>

    <svg
      v-if="icon === 'rust'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M191.53,96.12a8.08,8.08,0,1,1,8.07,8.08,8.07,8.07,0,0,1-8.07-8.08M95.16,169.25a8.08,8.08,0,0,1,16.15,0h0a8.08,8.08,0,1,1-16.15,0m192.73.38A8.08,8.08,0,1,1,296,177.7a8.08,8.08,0,0,1-8.08-8.07M118.53,180.72a7.39,7.39,0,0,0,3.75-9.73l-3.59-8.11h14.1v63.53H104.35a99.51,99.51,0,0,1-3.22-38Zm59,1.56V163.55h33.57c1.73,0,12.23,2,12.23,9.86,0,6.52-8.07,8.86-14.69,8.86ZM131.66,283.11a8.08,8.08,0,1,1,8.08,8.08,8.08,8.08,0,0,1-8.08-8.08m119.7.37a8.08,8.08,0,1,1,8.08,8.08,8.08,8.08,0,0,1-8.08-8.08m2.5-18.32a7.36,7.36,0,0,0-8.75,5.67l-4.05,18.92a99.48,99.48,0,0,1-82.94-.4l-4.05-18.92a7.36,7.36,0,0,0-8.75-5.67l-16.71,3.59A98.67,98.67,0,0,1,120,258.16h81.28c.92,0,1.53-.17,1.53-1V228.41c0-.85-.61-1-1.53-1H177.48V209.18h25.71c2.34,0,12.54.68,15.81,13.71l4.8,21.23c1.53,4.67,7.76,14,14.38,14h42a99.55,99.55,0,0,1-9.22,10.66ZM299,189.25a98.51,98.51,0,0,1,.22,17.26H289c-1,0-1.44.68-1.44,1.68v4.69c0,11-6.22,13.41-11.67,14-5.18.6-11-2.17-11.65-5.35-3.06-17.22-8.16-20.89-16.14-27.26,10-6.35,20.4-15.71,20.4-28.26,0-13.54-9.28-22.06-15.61-26.24a44.22,44.22,0,0,0-21.35-7H125.93a99.53,99.53,0,0,1,55.64-31.4L194,114.43a7.37,7.37,0,0,0,10.42.23l13.93-13.3a99.41,99.41,0,0,1,68.09,48.48l-9.53,21.53a7.39,7.39,0,0,0,3.75,9.73Zm23.77.34-.32-3.33,9.82-9.16a4.09,4.09,0,0,0-1.3-6.56l-12.55-4.69-1-3.22,7.81-10.87a4.09,4.09,0,0,0-2.55-6.18l-13.23-2.15-1.59-3,5.56-12.21a4.07,4.07,0,0,0-3.71-5.56l-13.42.47-2.12-2.58,3.08-13.08a4.09,4.09,0,0,0-4.73-4.73l-13.08,3.09-2.58-2.13.47-13.42a4.09,4.09,0,0,0-5.56-3.71l-12.2,5.57-3-1.6-2.16-13.23a4.07,4.07,0,0,0-6.17-2.55L237.41,82.6l-3.23-1-4.69-12.54a4.08,4.08,0,0,0-6.55-1.31l-9.16,9.82-3.33-.32-7.07-11.43a4.09,4.09,0,0,0-6.68,0l-7.07,11.43-3.33.32-9.17-9.84a4.09,4.09,0,0,0-6.56,1.31l-4.69,12.55-3.22,1-10.88-7.81a4.08,4.08,0,0,0-6.17,2.55l-2.16,13.23-3,1.6-12.2-5.57a4.08,4.08,0,0,0-5.55,3.72l.47,13.42-2.59,2.12-13.08-3.08a4.09,4.09,0,0,0-4.73,4.73l3.09,13.08-2.13,2.57-13.42-.47a4.09,4.09,0,0,0-3.71,5.57l5.56,12.2-1.59,3-13.24,2.14a4.08,4.08,0,0,0-2.54,6.18l7.81,10.87-1,3.23L69.1,170.53a4.08,4.08,0,0,0-1.3,6.55l9.82,9.16-.32,3.33-11.43,7.07a4.09,4.09,0,0,0,0,6.68l11.43,7.07.32,3.33-9.84,9.19a4.08,4.08,0,0,0,1.3,6.55l12.54,4.69,1,3.23-7.82,10.87a4.09,4.09,0,0,0,2.55,6.18l13.22,2.14,1.6,3L86.6,271.74a4.09,4.09,0,0,0,3.71,5.57l13.42-.47,2.12,2.58-3.08,13.08a4.08,4.08,0,0,0,4.73,4.72l13.08-3.08,2.58,2.12-.47,13.42a4.09,4.09,0,0,0,5.56,3.72l12.2-5.57,3,1.6,2.16,13.22a4.08,4.08,0,0,0,6.17,2.57l10.87-7.83,3.23,1,4.69,12.55a4.09,4.09,0,0,0,6.56,1.3l9.15-9.82,3.33.34,7.07,11.42a4.09,4.09,0,0,0,6.68,0l7.07-11.42,3.33-.34,9.15,9.82a4.09,4.09,0,0,0,6.56-1.3l4.69-12.55,3.23-1,10.87,7.83a4.08,4.08,0,0,0,6.17-2.57l2.16-13.22,3-1.6,12.2,5.57a4.08,4.08,0,0,0,5.56-3.72l-.47-13.42,2.57-2.12,13.08,3.08a4.08,4.08,0,0,0,4.73-4.72l-3.08-13.08,2.12-2.58,13.42.47a4.09,4.09,0,0,0,3.71-5.57l-5.56-12.19,1.59-3,13.23-2.14a4.07,4.07,0,0,0,2.55-6.18l-7.81-10.87,1-3.23,12.55-4.69a4.08,4.08,0,0,0,1.3-6.55l-9.82-9.16.32-3.33,11.42-7.07a4.08,4.08,0,0,0,0-6.68Z"
      />
    </svg>

    <svg
      v-if="icon === 'vcv'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M200,74.46A125.55,125.55,0,1,0,325.54,200v0A125.54,125.54,0,0,0,200,74.46Zm.19,79a46.53,46.53,0,1,0-3.34,93c1.11,0,2.23,0,3.34,0a46.09,46.09,0,0,0,27.9-9.3,20.68,20.68,0,0,1,24.84,33.07,87.89,87.89,0,1,1,0-140.59,20.68,20.68,0,1,1-24.19,33.55c-.22-.16-.44-.32-.65-.49a46.08,46.08,0,0,0-27.9-9.24ZM226.88,200A26.88,26.88,0,1,1,200,173.12,26.87,26.87,0,0,1,226.88,200Z"
      />
    </svg>
    <svg
      v-if="icon === 'obs'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path
        class="cls-1"
        d="M200.39,64.11A135.89,135.89,0,1,0,336.28,200,135.89,135.89,0,0,0,200.39,64.11Zm90,119.91a57.9,57.9,0,0,0-83.89,34A60.46,60.46,0,0,0,211,262.86c-9.79,17-27.48,29.07-46.69,32.72-14.76,3.1-30.29.7-44-5.51,12.3,3.59,25.66,4.22,37.88-.13a58.34,58.34,0,0,0,35.91-34.84c6.61-17.69,4.1-38.72-7-53.9a58.42,58.42,0,0,0-35.64-23.39c-4.52-.8-9.07-1.17-13.63-1.58-7.25-14.62-9.91-31.58-6.26-47.45l-.23-.14c4.18-20.16,17.84-38.34,36.21-47.45-3.19,3.25-7.06,5.73-10,9.26a57.81,57.81,0,0,0-14.23,49.35c4.21,26.53,29.15,48.2,56.17,47.83,21,.93,41.38-11.13,51.63-29.31,21.94.75,43.27,12.07,55.8,30.25,6.41,9.49,11.42,20.62,11.76,32.19A59.57,59.57,0,0,0,290.43,184Z"
      />
    </svg>

    <svg
      v-if="icon === 'vue'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <g id="first">
        <path
          class="cls-1"
          d="M233.49,74.42l-33.49,58-33.49-58H55L200,325.58,345,74.42Z"
        />
      </g>
      <g id="second">
        <path
          class="cls-2"
          d="M233.49,74.42l-33.49,58-33.49-58H113l87,150.69L287,74.42Z"
        />
      </g>
    </svg>

    <svg
      v-if="icon === 'linkedin'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
    >
      <path
        id="BG"
        class="cls-1"
        d="M0,0V1000H1000V0ZM816,770.39A46.43,46.43,0,0,1,769.19,816H230.63A46.36,46.36,0,0,1,184,770.39V229.6A46.33,46.33,0,0,1,230.63,184H769.19A46.41,46.41,0,0,1,816,229.56Z"
      />
      <rect class="cls-1" x="277.69" y="420.92" width="93.74" height="301.59" />
      <path
        class="cls-1"
        d="M378.94,325.34h0a54.59,54.59,0,0,1-54.33,54.34h0A54.34,54.34,0,1,1,379,325.33Z"
      />
      <path
        class="cls-1"
        d="M722.55,557.07V722.51H628.86V575.85c0-35-.62-80-48.7-80-48.78,0-56.24,38.11-56.24,77.45V722.5H430.27V420.92h89.9v41.21h1.26a98.64,98.64,0,0,1,88.7-48.71C705.05,413.42,722.55,475.85,722.55,557.07Z"
      />
    </svg>

    <svg
      v-if="icon === 'github'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
    >
      <path
        class="cls-1"
        d="M569.8,638.39c14.08,12.12,26.62,36.06,26.62,72.65,0,52.44-.48,94.74-.48,107.6,0,5.25,1.77,12.46,6,16.34H395.29c4.32-3.88,6.15-11.07,6.15-16.32,0-9.31-.34-34-.54-66.71-109.09,23.69-132.12-52.61-132.12-52.61C250.94,654,225.23,642,225.23,642c-35.61-24.34,2.7-23.84,2.7-23.84C267.29,620.9,288,658.55,288,658.55c35,59.94,91.81,42.63,114.16,32.59,3.56-25.35,13.7-42.64,24.9-52.43C340,628.8,248.39,595.16,248.39,444.83c0-42.82,15.28-77.83,40.37-105.25-4-9.93-17.5-49.8,3.85-103.82,0,0,32.94-10.54,107.86,40.22a371.6,371.6,0,0,1,196.4,0c74.88-50.76,107.76-40.22,107.76-40.22,21.39,54,7.93,93.89,3.94,103.82C733.71,367,748.89,402,748.89,444.83,748.89,595.53,657.17,628.68,569.8,638.39Z"
      />
    </svg>

    <svg
      v-if="icon === 'artstation'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
    >
      <path
        class="cls-1"
        d="M194.51,233.59l-106.43,0A19.27,19.27,0,0,1,71,223L55,195.36H172.43Z"
      />
      <polygon
        class="cls-1"
        points="156.82 168 70.82 168 113.92 93.55 156.82 168"
      />
      <path
        class="cls-1"
        d="M244.92,195.5c0,4.31-.87,6.5-3.74,11.5l-15.26,26.39L129.54,66.45h33a19,19,0,0,1,16.87,10.23l62.46,108.41A19,19,0,0,1,244.92,195.5Z"
      />
    </svg>

    <svg
      v-if="icon === 'spotify'"
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
    >
      <path
        class="cls-1"
        d="M511.94,204c-166.37-.49-307.33,133.58-307.44,306.87C204.39,681.29,341.15,816.7,509,818.12,682.6,819.59,818.93,680,819.25,512.29v-2.06C819,340.8,681.36,203.7,511.94,204ZM652.2,646c-5.44,9-16.61,11.81-26,6.12-35.49-21.53-74.06-34.08-115.07-39.43-15.53-2-31.15-3.16-41.61-3A502.31,502.31,0,0,0,358.15,622.4c-9.85,2.21-18.31-1.45-22.26-9.62a18.43,18.43,0,0,1,4.84-22.27,19,19,0,0,1,8.24-3.94A563,563,0,0,1,420,575a441.78,441.78,0,0,1,50-2.39c54.28,1,106.38,11.55,155,36.5,6.9,3.53,13.67,7.36,20.3,11.38C654.66,626.22,657.51,637.16,652.2,646Zm39.7-88.09A23.41,23.41,0,0,1,657,570.17c-40.6-24.53-84.94-38.3-131.52-45.57a412.61,412.61,0,0,0-77-5c-32.6,1-64.71,5.4-96.05,14.77-11.14,3.33-21.21-.13-27.4-9.23-5.44-8-4.78-19.6,1.54-27.46a23.6,23.6,0,0,1,12-7.75,404.69,404.69,0,0,1,68.73-14.07A396.6,396.6,0,0,1,460.78,473c61.65-.06,121.08,11.09,177.88,35.4a300.57,300.57,0,0,1,43.6,22.69A22.76,22.76,0,0,1,691.9,557.91Zm42.83-97.74C729,477.46,710,484.76,693.62,475.6a348.64,348.64,0,0,0-42.29-20.42c-31.49-12.44-64.16-20.25-97.54-25.43a576.39,576.39,0,0,0-110.36-5.94c-36.07,1.37-71.74,6-106.5,16.31-12.33,3.65-25-1-31.66-11.22a28.08,28.08,0,0,1,16-42.63c24.91-7.38,50.34-12,76.13-15.09,23.15-2.76,46.4-3.37,66-4.09,67.74.67,130.64,8.77,191.52,29.65a368.82,368.82,0,0,1,64.8,29.16C733.47,433.81,739.15,446.93,734.73,460.17Z"
      />
    </svg>

    <svg
      v-if="icon === 'spaceclouds'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 800"
    >
      <g id="Wolken" class="cls-1">
        <path
          class="cls-5"
          d="M1920,64.72a264.75,264.75,0,0,0-15.91,183.46,263.05,263.05,0,0,0-78.84,188.09c0,6.63.26,13.2.74,19.7a215.31,215.31,0,0,0-131.74-7.25A146.13,146.13,0,0,0,1492,611.23a215.74,215.74,0,0,0-112.68,1,133.44,133.44,0,0,0-254.36,7.32,81,81,0,0,0-104.38,54.87,74.23,74.23,0,0,0-78-21.5,81,81,0,0,0-114.13-38.18,133.44,133.44,0,0,0-255.85,7.2,213.6,213.6,0,0,0-85.4-17.7c-7.11,0-14.13.36-21.06,1A148,148,0,0,0,468,582.33,146.06,146.06,0,0,0,235.11,464.84a214.08,214.08,0,0,0-112-62.58,263.53,263.53,0,0,0-79.81-139.7A264.56,264.56,0,0,0,50.59,201,262.64,262.64,0,0,0,0,45.6V0H16.58A297.6,297.6,0,0,1,94.33,201a300.6,300.6,0,0,1-5.66,58.1A297.94,297.94,0,0,1,155.39,387,242,242,0,0,1,229.6,423.8,165.36,165.36,0,0,1,487.22,561c0,.34,0,.68,0,1a241.45,241.45,0,0,1,63.89,14.72A151.05,151.05,0,0,1,832,589.81,91.72,91.72,0,0,1,943.12,621a84,84,0,0,1,69.64-2.4,91.71,91.71,0,0,1,109.32-28.77A151.05,151.05,0,0,1,1403,576.74,241.45,241.45,0,0,1,1466.9,562c0-.34,0-.68,0-1a165.36,165.36,0,0,1,257.62-137.2A242,242,0,0,1,1798.72,387a297.94,297.94,0,0,1,66.72-127.89,300.6,300.6,0,0,1-5.66-58.1A297.34,297.34,0,0,1,1920,21.13Z"
        />
        <path
          class="cls-3"
          d="M1920,64.72V800H0V45.6A262.64,262.64,0,0,1,50.59,201a264.56,264.56,0,0,1-7.24,61.56,263.53,263.53,0,0,1,79.81,139.7,214.08,214.08,0,0,1,112,62.58A146.06,146.06,0,0,1,468,582.33a148,148,0,0,1-1.79,22.93c6.93-.67,13.95-1,21.06-1a213.6,213.6,0,0,1,85.4,17.7,133.44,133.44,0,0,1,255.85-7.2A81,81,0,0,1,942.6,652.91a74.23,74.23,0,0,1,78,21.5,81,81,0,0,1,104.38-54.87,133.44,133.44,0,0,1,254.36-7.32,215.74,215.74,0,0,1,112.68-1,146.12,146.12,0,0,1,202.27-162.51A215.31,215.31,0,0,1,1826,456c-.48-6.5-.74-13.07-.74-19.7a263.05,263.05,0,0,1,78.84-188.09A264.75,264.75,0,0,1,1920,64.72Z"
        />
      </g>
      <g id="Stars" class="cls-4">
        <g>
          <circle class="cls-2" cx="27.33" cy="345.99" r="3.99" />
          <circle class="cls-2" cx="68.68" cy="347.91" r="4.73" />
          <circle class="cls-2" cx="52.01" cy="378.19" r="3.36" />
          <circle class="cls-2" cx="72.84" cy="401.99" r="4.43" />
          <circle class="cls-2" cx="65.51" cy="418.86" r="4.32" />
          <circle class="cls-2" cx="94.43" cy="425.08" r="3.7" />
          <circle class="cls-2" cx="87.84" cy="450.93" r="3.26" />
          <circle class="cls-2" cx="25.79" cy="493.76" r="4.46" />
          <circle class="cls-2" cx="98.23" cy="477.37" r="2.1" />
          <circle class="cls-2" cx="41.63" cy="509.44" r="1.49" />
          <circle class="cls-2" cx="126.81" cy="486.88" r="4.23" />
          <circle class="cls-2" cx="125.07" cy="485.87" r="1.83" />
          <circle class="cls-2" cx="23.38" cy="567.11" r="2.61" />
          <circle class="cls-2" cx="107.06" cy="523.08" r="4.27" />
          <circle class="cls-2" cx="85.89" cy="550.45" r="1.67" />
          <circle class="cls-2" cx="117.05" cy="535.24" r="2.73" />
          <circle class="cls-2" cx="118.48" cy="526.25" r="4.12" />
          <circle class="cls-2" cx="105.63" cy="573.81" r="4.29" />
          <circle class="cls-2" cx="100.39" cy="618.4" r="4.89" />
          <circle class="cls-2" cx="125.8" cy="579.97" r="3.79" />
          <circle class="cls-2" cx="130.14" cy="526.87" r="4.44" />
          <circle class="cls-2" cx="146.55" cy="600.1" r="3.81" />
          <circle class="cls-2" cx="172.13" cy="647.85" r="2.7" />
          <circle class="cls-2" cx="166.43" cy="557.99" r="1.79" />
          <circle class="cls-2" cx="191.68" cy="629.89" r="1.41" />
          <circle class="cls-2" cx="205.63" cy="615.87" r="1.38" />
          <circle class="cls-2" cx="198.38" cy="561.04" r="1.23" />
          <circle class="cls-2" cx="187.26" cy="488.54" r="4.29" />
          <circle class="cls-2" cx="228.35" cy="568.35" r="2.01" />
          <circle class="cls-2" cx="238.41" cy="547.92" r="1.03" />
          <circle class="cls-2" cx="250.21" cy="580.61" r="3.59" />
          <circle class="cls-2" cx="264.31" cy="567.66" r="2.82" />
          <circle class="cls-2" cx="286.69" cy="488.26" r="3.11" />
          <circle class="cls-2" cx="286.65" cy="537.13" r="3.26" />
          <circle class="cls-2" cx="304.96" cy="543.41" r="3.63" />
          <circle class="cls-2" cx="330.39" cy="525.91" r="2.28" />
          <circle class="cls-2" cx="312.35" cy="576.74" r="3.96" />
          <circle class="cls-2" cx="293.93" cy="610.81" r="2.79" />
          <circle class="cls-2" cx="290.79" cy="628.48" r="2.93" />
          <circle class="cls-2" cx="394.22" cy="554.51" r="1.63" />
          <circle class="cls-2" cx="347.13" cy="606.55" r="1.24" />
          <circle class="cls-2" cx="373.2" cy="601.89" r="2.35" />
          <circle class="cls-2" cx="427.7" cy="571.92" r="3.32" />
          <circle class="cls-2" cx="332.15" cy="649.37" r="3.59" />
          <circle class="cls-2" cx="300.74" cy="677.11" r="4.2" />
          <circle class="cls-2" cx="402.52" cy="628.37" r="1.43" />
          <circle class="cls-2" cx="313.42" cy="678.58" r="3.78" />
          <circle class="cls-2" cx="393.18" cy="655.28" r="2.17" />
          <circle class="cls-2" cx="374.81" cy="680.86" r="1.64" />
          <circle class="cls-2" cx="312.28" cy="704.29" r="2.97" />
          <circle class="cls-2" cx="365.5" cy="705.18" r="3.5" />
          <circle class="cls-2" cx="374.26" cy="714.62" r="4.06" />
        </g>
        <g>
          <circle class="cls-2" cx="15.39" cy="650.04" r="4.66" />
          <circle class="cls-2" cx="35.94" cy="705.88" r="3.01" />
          <circle class="cls-2" cx="41.42" cy="694.88" r="0.96" />
          <circle class="cls-2" cx="49.75" cy="706.71" r="1.69" />
          <circle class="cls-2" cx="51.34" cy="661.81" r="2.98" />
          <circle class="cls-2" cx="75.89" cy="749.12" r="1.33" />
          <circle class="cls-2" cx="78.53" cy="620.11" r="2.85" />
          <circle class="cls-2" cx="96" cy="656.5" r="3.75" />
          <circle class="cls-2" cx="104.99" cy="668.97" r="1.91" />
          <circle class="cls-2" cx="116.81" cy="681.14" r="2.67" />
          <circle class="cls-2" cx="124.55" cy="741.98" r="3.49" />
          <circle class="cls-2" cx="141.69" cy="638.3" r="3.34" />
          <circle class="cls-2" cx="151.47" cy="620.42" r="1.48" />
          <circle class="cls-2" cx="165.74" cy="663.45" r="2.81" />
          <circle class="cls-2" cx="163.33" cy="750.44" r="2.38" />
          <circle class="cls-2" cx="166.26" cy="766.66" r="2.89" />
          <circle class="cls-2" cx="193.68" cy="616.27" r="4.16" />
          <circle class="cls-2" cx="178.38" cy="768.46" r="2.65" />
          <circle class="cls-2" cx="192.15" cy="729.01" r="4.29" />
          <circle class="cls-2" cx="204.82" cy="690.59" r="2.11" />
          <circle class="cls-2" cx="217.73" cy="662.45" r="1.45" />
          <circle class="cls-2" cx="226.59" cy="696.37" r="4.26" />
          <circle class="cls-2" cx="229.61" cy="719.08" r="3.46" />
          <circle class="cls-2" cx="266.87" cy="623.62" r="2.42" />
          <circle class="cls-2" cx="264.79" cy="691.08" r="0.95" />
          <circle class="cls-2" cx="264.96" cy="720.59" r="3.43" />
          <circle class="cls-2" cx="271.25" cy="755" r="4.24" />
          <circle class="cls-2" cx="295.17" cy="725.69" r="4.04" />
        </g>
        <g>
          <circle class="cls-2" cx="408.59" cy="680.18" r="2.17" />
          <circle class="cls-2" cx="415.18" cy="698.43" r="3.54" />
          <circle class="cls-2" cx="423.32" cy="718.7" r="4.42" />
          <circle class="cls-2" cx="422.08" cy="712.57" r="1.62" />
          <circle class="cls-2" cx="461.44" cy="765.59" r="3.53" />
          <circle class="cls-2" cx="501.53" cy="800.07" r="2.75" />
          <circle class="cls-2" cx="491.17" cy="761.37" r="3.51" />
          <circle class="cls-2" cx="473.45" cy="709.79" r="4.15" />
          <circle class="cls-2" cx="450.58" cy="642.49" r="0.91" />
          <circle class="cls-2" cx="498.17" cy="686.33" r="2.49" />
          <circle class="cls-2" cx="514.88" cy="708.86" r="1.99" />
          <circle class="cls-2" cx="500.59" cy="746.28" r="3.79" />
          <circle class="cls-2" cx="512.32" cy="760.21" r="2.82" />
          <circle class="cls-2" cx="508.09" cy="784.94" r="2.57" />
          <circle class="cls-2" cx="520.75" cy="770.79" r="2.99" />
          <circle class="cls-2" cx="586.71" cy="664.28" r="3.91" />
          <circle class="cls-2" cx="576.71" cy="659.93" r="0.95" />
          <circle class="cls-2" cx="569.06" cy="758.81" r="2.63" />
          <circle class="cls-2" cx="577.38" cy="756.23" r="4.42" />
          <circle class="cls-2" cx="587.56" cy="669.34" r="0.91" />
          <circle class="cls-2" cx="603.87" cy="721.52" r="2.95" />
          <circle class="cls-2" cx="607.75" cy="663.67" r="3.61" />
          <circle class="cls-2" cx="632.99" cy="743.1" r="3.69" />
          <circle class="cls-2" cx="617.52" cy="670.12" r="4.24" />
          <circle class="cls-2" cx="621.92" cy="646.7" r="2.95" />
          <circle class="cls-2" cx="633.79" cy="672.02" r="4.33" />
          <circle class="cls-2" cx="625.08" cy="655.79" r="4.44" />
          <circle class="cls-2" cx="717" cy="771.01" r="3.21" />
          <circle class="cls-2" cx="669.55" cy="691.9" r="1.74" />
          <circle class="cls-2" cx="723.8" cy="752.71" r="1.95" />
          <circle class="cls-2" cx="719.26" cy="716.56" r="4.14" />
          <circle class="cls-2" cx="709.8" cy="718.46" r="4.46" />
          <circle class="cls-2" cx="756.26" cy="647.61" r="1.63" />
          <circle class="cls-2" cx="761.65" cy="696.61" r="0.94" />
          <circle class="cls-2" cx="730.06" cy="711.18" r="2.79" />
          <circle class="cls-2" cx="710.69" cy="690.17" r="1.55" />
          <circle class="cls-2" cx="710.62" cy="705.49" r="3.94" />
          <circle class="cls-2" cx="707.37" cy="704.35" r="2.34" />
          <circle class="cls-2" cx="653.53" cy="788.12" r="2.13" />
          <circle class="cls-2" cx="669.38" cy="717.3" r="1.62" />
          <circle class="cls-2" cx="688.54" cy="664.15" r="2.72" />
          <circle class="cls-2" cx="643.68" cy="727.88" r="4.39" />
          <circle class="cls-2" cx="640.67" cy="697.5" r="2.24" />
          <circle class="cls-2" cx="660.72" cy="659.88" r="3.93" />
          <circle class="cls-2" cx="652.16" cy="661.02" r="4.69" />
          <circle class="cls-2" cx="605.02" cy="658.79" r="2.94" />
          <circle class="cls-2" cx="664.23" cy="652.53" r="2.12" />
          <circle class="cls-2" cx="648.23" cy="643.88" r="4.59" />
          <circle class="cls-2" cx="631.48" cy="625.92" r="2.44" />
          <circle class="cls-2" cx="682.54" cy="670.65" r="4.74" />
          <circle class="cls-2" cx="672.4" cy="631.84" r="3.43" />
          <circle class="cls-2" cx="680.25" cy="620.65" r="1.21" />
          <circle class="cls-2" cx="672.21" cy="680.64" r="1.82" />
          <circle class="cls-2" cx="654.06" cy="690.94" r="3.22" />
          <circle class="cls-2" cx="707.2" cy="642.85" r="1.04" />
          <circle class="cls-2" cx="685.31" cy="676.85" r="1.4" />
          <circle class="cls-2" cx="719.37" cy="669.28" r="2.86" />
          <circle class="cls-2" cx="746.57" cy="662.52" r="2.05" />
          <circle class="cls-2" cx="725.49" cy="686.83" r="3.03" />
          <circle class="cls-2" cx="774.94" cy="669.81" r="4.39" />
          <circle class="cls-2" cx="726.52" cy="718.37" r="2.97" />
          <circle class="cls-2" cx="711.92" cy="742.76" r="3.5" />
          <circle class="cls-2" cx="744.63" cy="726.1" r="4.2" />
          <circle class="cls-2" cx="734.52" cy="748.29" r="4.43" />
        </g>
        <g>
          <circle class="cls-2" cx="1071.03" cy="767.52" r="2.5" />
          <circle class="cls-2" cx="1074.48" cy="715.25" r="2.53" />
          <circle class="cls-2" cx="1041.71" cy="801.55" r="3.5" />
          <circle class="cls-2" cx="1055.73" cy="728.19" r="3.32" />
          <circle class="cls-2" cx="1032" cy="757.05" r="3.22" />
          <circle class="cls-2" cx="1016.88" cy="785.88" r="2.59" />
          <circle class="cls-2" cx="1009.5" cy="763.74" r="4.31" />
          <circle class="cls-2" cx="998.67" cy="749.95" r="4.51" />
          <circle class="cls-2" cx="987.83" cy="802.34" r="3.1" />
          <circle class="cls-2" cx="980.6" cy="770.41" r="4.6" />
          <circle class="cls-2" cx="968.89" cy="752.44" r="1.74" />
          <circle class="cls-2" cx="959.27" cy="689.32" r="3.3" />
          <circle class="cls-2" cx="936.65" cy="791.74" r="3.37" />
          <circle class="cls-2" cx="930.21" cy="702.87" r="1.11" />
          <circle class="cls-2" cx="917.93" cy="757.18" r="1.36" />
          <circle class="cls-2" cx="897.39" cy="794.53" r="3.09" />
          <circle class="cls-2" cx="898.25" cy="741.69" r="2.47" />
          <circle class="cls-2" cx="869.03" cy="796.11" r="2.24" />
          <circle class="cls-2" cx="864.13" cy="725.7" r="3.41" />
          <circle class="cls-2" cx="866.83" cy="688.46" r="2.15" />
          <circle class="cls-2" cx="830.59" cy="747.51" r="4.21" />
          <circle class="cls-2" cx="800.38" cy="791.41" r="2.19" />
          <circle class="cls-2" cx="811.63" cy="738.68" r="4.81" />
          <circle class="cls-2" cx="816.53" cy="681.38" r="1.18" />
          <circle class="cls-2" cx="797.89" cy="698.11" r="2.2" />
          <circle class="cls-2" cx="766.82" cy="736.23" r="4.84" />
        </g>
        <g>
          <circle class="cls-2" cx="1423.99" cy="697.01" r="2.53" />
          <circle class="cls-2" cx="1412.99" cy="724.79" r="1.13" />
          <circle class="cls-2" cx="1410.91" cy="712.49" r="3.36" />
          <circle class="cls-2" cx="1399.25" cy="729.54" r="4.27" />
          <circle class="cls-2" cx="1373.88" cy="778.34" r="3.84" />
          <circle class="cls-2" cx="1386.75" cy="727.96" r="3.36" />
          <circle class="cls-2" cx="1293.72" cy="799" r="3.05" />
          <circle class="cls-2" cx="1291.99" cy="784.82" r="3.51" />
          <circle class="cls-2" cx="1394.92" cy="701.27" r="4.8" />
          <circle class="cls-2" cx="1371.05" cy="711.09" r="3.39" />
          <circle class="cls-2" cx="1385.18" cy="685.55" r="3.76" />
          <circle class="cls-2" cx="1366.41" cy="681.8" r="3.77" />
          <circle class="cls-2" cx="1287.64" cy="736.47" r="4.57" />
          <circle class="cls-2" cx="1347.89" cy="648.26" r="3.38" />
          <circle class="cls-2" cx="1272.97" cy="751.84" r="2.78" />
          <circle class="cls-2" cx="1297.2" cy="667.63" r="2.32" />
          <circle class="cls-2" cx="1276.41" cy="716.02" r="0.96" />
          <circle class="cls-2" cx="1275.18" cy="618.17" r="2.98" />
          <circle class="cls-2" cx="1266.39" cy="584.89" r="4.86" />
          <circle class="cls-2" cx="1262.75" cy="696.35" r="1.83" />
          <circle class="cls-2" cx="1250.17" cy="584.2" r="2.59" />
          <circle class="cls-2" cx="1256.07" cy="737.96" r="4.51" />
          <circle class="cls-2" cx="1240.81" cy="734.3" r="2.16" />
          <circle class="cls-2" cx="1201.49" cy="607.12" r="3.04" />
          <circle class="cls-2" cx="1230.63" cy="725.53" r="4.23" />
          <circle class="cls-2" cx="1226.46" cy="749.01" r="4.71" />
          <circle class="cls-2" cx="1196.53" cy="670.09" r="1.46" />
          <circle class="cls-2" cx="1188.64" cy="665.21" r="0.97" />
          <circle class="cls-2" cx="1196.44" cy="703.13" r="3.17" />
          <circle class="cls-2" cx="1143.56" cy="614.6" r="2.59" />
          <circle class="cls-2" cx="1207.09" cy="770.54" r="2.99" />
          <circle class="cls-2" cx="1164.29" cy="709.97" r="1.62" />
          <circle class="cls-2" cx="1189.38" cy="747.11" r="4.44" />
          <circle class="cls-2" cx="1140.75" cy="701.08" r="1.95" />
          <circle class="cls-2" cx="1161.69" cy="732.83" r="4.49" />
          <circle class="cls-2" cx="1182.6" cy="766.13" r="4.21" />
          <circle class="cls-2" cx="1153.46" cy="743.69" r="4.11" />
          <circle class="cls-2" cx="1163.8" cy="763.98" r="2.41" />
          <circle class="cls-2" cx="1186.04" cy="781.17" r="1.65" />
        </g>
        <g>
          <circle class="cls-2" cx="1847.6" cy="375.67" r="0.87" />
          <circle class="cls-2" cx="1867.23" cy="415.61" r="4.76" />
          <circle class="cls-2" cx="1839.65" cy="432.9" r="4.76" />
          <circle class="cls-2" cx="1912.6" cy="482.46" r="1.6" />
          <circle class="cls-2" cx="1865.85" cy="478.42" r="4.31" />
          <circle class="cls-2" cx="1915.5" cy="515.85" r="3.16" />
          <circle class="cls-2" cx="1844.5" cy="505.1" r="1.41" />
          <circle class="cls-2" cx="1797.93" cy="492.42" r="1.92" />
          <circle class="cls-2" cx="1829.42" cy="518.92" r="1.04" />
          <circle class="cls-2" cx="1867.43" cy="540.01" r="4.2" />
          <circle class="cls-2" cx="1839.7" cy="542.02" r="0.94" />
          <circle class="cls-2" cx="1840.78" cy="554.68" r="2.85" />
          <circle class="cls-2" cx="1790.95" cy="580.27" r="1.15" />
          <circle class="cls-2" cx="1872.86" cy="624.26" r="4.48" />
          <circle class="cls-2" cx="1806.83" cy="635.83" r="2.24" />
          <circle class="cls-2" cx="1898.15" cy="668.21" r="3.82" />
          <circle class="cls-2" cx="1914.17" cy="710.17" r="1.43" />
          <circle class="cls-2" cx="1841.07" cy="677.86" r="2.6" />
          <circle class="cls-2" cx="1828.18" cy="675.31" r="4.87" />
          <circle class="cls-2" cx="1846.99" cy="717.19" r="3" />
          <circle class="cls-2" cx="1852.72" cy="736.22" r="4.62" />
          <circle class="cls-2" cx="1871.04" cy="773.95" r="1.87" />
          <circle class="cls-2" cx="1800.01" cy="639.63" r="1.52" />
          <circle class="cls-2" cx="1795.09" cy="666.73" r="2.65" />
          <circle class="cls-2" cx="1794.42" cy="715.7" r="3.07" />
          <circle class="cls-2" cx="1787.93" cy="633.99" r="2.03" />
          <circle class="cls-2" cx="1784.51" cy="658.64" r="2.14" />
          <circle class="cls-2" cx="1760.23" cy="732.25" r="3.37" />
          <circle class="cls-2" cx="1731.18" cy="771.23" r="2.69" />
          <circle class="cls-2" cx="1754.3" cy="691.73" r="3.78" />
          <circle class="cls-2" cx="1756.87" cy="682.34" r="0.99" />
          <circle class="cls-2" cx="1694.33" cy="735.97" r="3.06" />
          <circle class="cls-2" cx="1751.05" cy="676.84" r="1.86" />
          <circle class="cls-2" cx="1813.96" cy="675.26" r="1.61" />
          <circle class="cls-2" cx="1689.58" cy="648.31" r="3.06" />
          <circle class="cls-2" cx="1709.09" cy="611.16" r="1.01" />
          <circle class="cls-2" cx="1752.67" cy="665.66" r="3.83" />
          <circle class="cls-2" cx="1739.09" cy="629.23" r="1.74" />
          <circle class="cls-2" cx="1763.07" cy="689.29" r="0.93" />
          <circle class="cls-2" cx="1758.57" cy="567.31" r="2.1" />
          <circle class="cls-2" cx="1784.82" cy="628.06" r="4.5" />
          <circle class="cls-2" cx="1776.9" cy="670.97" r="1.96" />
          <circle class="cls-2" cx="1795.91" cy="654.56" r="4.09" />
          <circle class="cls-2" cx="1755.97" cy="698.24" r="1.28" />
          <circle class="cls-2" cx="1749.44" cy="711.65" r="3.86" />
          <circle class="cls-2" cx="1893.43" cy="660.23" r="2.01" />
          <circle class="cls-2" cx="1883.45" cy="673.42" r="2.81" />
          <circle class="cls-2" cx="1794.26" cy="703.34" r="3.08" />
          <circle class="cls-2" cx="1767.45" cy="716.47" r="4.1" />
          <circle class="cls-2" cx="1787.82" cy="722.86" r="2.45" />
          <circle class="cls-2" cx="1797.46" cy="727.64" r="1.5" />
          <circle class="cls-2" cx="1753.07" cy="697.06" r="2.35" />
          <circle class="cls-2" cx="1800.93" cy="782.33" r="3.6" />
          <circle class="cls-2" cx="1782.19" cy="742.93" r="4.26" />
          <circle class="cls-2" cx="1759.75" cy="706.55" r="2.63" />
          <circle class="cls-2" cx="1763.99" cy="797.41" r="4.92" />
          <circle class="cls-2" cx="1756.81" cy="772.84" r="3.5" />
          <circle class="cls-2" cx="1727.11" cy="793.11" r="4.05" />
          <circle class="cls-2" cx="1710.9" cy="695.11" r="1.39" />
          <circle class="cls-2" cx="1652.46" cy="799.95" r="2.44" />
          <circle class="cls-2" cx="1646.71" cy="799.85" r="3.79" />
          <circle class="cls-2" cx="1676.56" cy="769.29" r="1.61" />
          <circle class="cls-2" cx="1680.29" cy="737.84" r="0.9" />
          <circle class="cls-2" cx="1673.5" cy="665.76" r="4.6" />
          <circle class="cls-2" cx="1700.43" cy="710.89" r="2.85" />
          <circle class="cls-2" cx="1694.14" cy="653.27" r="4.49" />
          <circle class="cls-2" cx="1729.68" cy="755.58" r="2.6" />
          <circle class="cls-2" cx="1739.26" cy="764.08" r="2.98" />
          <circle class="cls-2" cx="1739.97" cy="730.97" r="4.45" />
          <circle class="cls-2" cx="1739.22" cy="671.63" r="0.99" />
          <circle class="cls-2" cx="1762.74" cy="708.9" r="4.36" />
          <circle class="cls-2" cx="1752.63" cy="653.23" r="2.63" />
          <circle class="cls-2" cx="1790.59" cy="737.74" r="2.01" />
          <circle class="cls-2" cx="1780.38" cy="684.68" r="1.82" />
          <circle class="cls-2" cx="1800.04" cy="684.21" r="1.38" />
          <circle class="cls-2" cx="1790.89" cy="660.26" r="4.88" />
          <circle class="cls-2" cx="1874.08" cy="690.77" r="3" />
          <circle class="cls-2" cx="1750.83" cy="626.54" r="2.79" />
          <circle class="cls-2" cx="1847.25" cy="659.91" r="3.46" />
          <circle class="cls-2" cx="1757.3" cy="620.8" r="3.05" />
          <circle class="cls-2" cx="1795.63" cy="618.31" r="2.78" />
          <circle class="cls-2" cx="1731.9" cy="600.54" r="2.06" />
          <circle class="cls-2" cx="1839.56" cy="604.45" r="3.13" />
          <circle class="cls-2" cx="1867" cy="547.75" r="4.83" />
          <circle class="cls-2" cx="1751.23" cy="654.81" r="4.43" />
          <circle class="cls-2" cx="1848" cy="520.44" r="2.65" />
          <circle class="cls-2" cx="1835.09" cy="518.49" r="4" />
          <circle class="cls-2" cx="1785.52" cy="559.09" r="3.04" />
          <circle class="cls-2" cx="1800.83" cy="515.37" r="1.12" />
          <circle class="cls-2" cx="1749.74" cy="561.85" r="3.28" />
          <circle class="cls-2" cx="1788.58" cy="495.66" r="2.45" />
          <circle class="cls-2" cx="1791.14" cy="482.42" r="3.61" />
          <circle class="cls-2" cx="1750.96" cy="503.13" r="4.54" />
          <circle class="cls-2" cx="1703.24" cy="576.36" r="1.57" />
          <circle class="cls-2" cx="1720.01" cy="511.12" r="1.17" />
          <circle class="cls-2" cx="1706.93" cy="527.03" r="1.82" />
          <circle class="cls-2" cx="1694.79" cy="516.02" r="1.95" />
          <circle class="cls-2" cx="1693.98" cy="570.51" r="1.49" />
          <circle class="cls-2" cx="1673.65" cy="543.82" r="3.08" />
          <circle class="cls-2" cx="1661.51" cy="565.67" r="2.26" />
          <circle class="cls-2" cx="1646.64" cy="554.42" r="4.42" />
          <circle class="cls-2" cx="1623.2" cy="502.46" r="2.17" />
          <circle class="cls-2" cx="1610.45" cy="489.59" r="1.16" />
          <circle class="cls-2" cx="1616.41" cy="617.21" r="1.25" />
          <circle class="cls-2" cx="1588.31" cy="517.16" r="2.98" />
          <circle class="cls-2" cx="1670.42" cy="504.58" r="3.84" />
          <circle class="cls-2" cx="1557.1" cy="574.59" r="1.44" />
          <circle class="cls-2" cx="1671.07" cy="534.16" r="1.03" />
          <circle class="cls-2" cx="1539.47" cy="589.69" r="2.65" />
          <circle class="cls-2" cx="1603.87" cy="577.93" r="4.81" />
          <circle class="cls-2" cx="1567.13" cy="584.22" r="2.47" />
          <circle class="cls-2" cx="1629.28" cy="599.54" r="2.63" />
          <circle class="cls-2" cx="1537.11" cy="597.93" r="1.74" />
          <circle class="cls-2" cx="1538.37" cy="577.3" r="4.45" />
          <circle class="cls-2" cx="1650.03" cy="666.46" r="2.51" />
          <circle class="cls-2" cx="1625.04" cy="666.07" r="3" />
          <circle class="cls-2" cx="1633.51" cy="692.13" r="1.92" />
          <circle class="cls-2" cx="1587.95" cy="666.25" r="4.63" />
          <circle class="cls-2" cx="1503.26" cy="601.17" r="3.49" />
          <circle class="cls-2" cx="1613.22" cy="716.79" r="2.29" />
          <circle class="cls-2" cx="1549.66" cy="675.06" r="4.69" />
          <circle class="cls-2" cx="1535.81" cy="669.63" r="1.91" />
          <circle class="cls-2" cx="1484.43" cy="629.17" r="1.3" />
          <circle class="cls-2" cx="1481.19" cy="644.56" r="1.57" />
          <circle class="cls-2" cx="1480.28" cy="663.36" r="0.98" />
        </g>
        <g>
          <circle class="cls-2" cx="1382.43" cy="700.53" r="2.75" />
          <circle class="cls-2" cx="1398.24" cy="797.07" r="4.76" />
          <circle class="cls-2" cx="1404.45" cy="752.46" r="4.75" />
          <circle class="cls-2" cx="1433.53" cy="775.75" r="4.15" />
          <circle class="cls-2" cx="1447.29" cy="790.74" r="3.26" />
          <circle class="cls-2" cx="1454.32" cy="732.87" r="3.2" />
          <circle class="cls-2" cx="1471.56" cy="782.74" r="4.48" />
          <circle class="cls-2" cx="1477.87" cy="687.88" r="4.85" />
          <circle class="cls-2" cx="1486.06" cy="726.39" r="4.63" />
          <circle class="cls-2" cx="1537.4" cy="772.68" r="4.58" />
          <circle class="cls-2" cx="1552.75" cy="796.34" r="2.19" />
          <circle class="cls-2" cx="1555.62" cy="691.94" r="1.62" />
          <circle class="cls-2" cx="1578.51" cy="778.39" r="4.68" />
          <circle class="cls-2" cx="1589.6" cy="750.83" r="1.86" />
          <circle class="cls-2" cx="1599.32" cy="799.39" r="3.92" />
          <circle class="cls-2" cx="1605.41" cy="710.91" r="4.2" />
          <circle class="cls-2" cx="1621.14" cy="784.85" r="4.04" />
          <circle class="cls-2" cx="1623.81" cy="692.08" r="3.27" />
          <circle class="cls-2" cx="1642.47" cy="798.96" r="1.91" />
          <circle class="cls-2" cx="1652.65" cy="768.75" r="3.18" />
          <circle class="cls-2" cx="1658.26" cy="712.71" r="2.59" />
          <circle class="cls-2" cx="1670.16" cy="677.21" r="3.22" />
          <circle class="cls-2" cx="1679.87" cy="762.61" r="1.61" />
        </g>
      </g>
    </svg>

    <svg v-if="icon === 'share'" width="32" height="32" viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"
      />
    </svg>
  </div>
</template>

<script>
import { toRef, ref, watch } from "vue";

export default {
  components: {},
  props: {
    icon: {
      type: String,
      default: "logo",
    },
    customClass: {
      type: String,
      default: "",
    },
    hovered: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const hoveredStatus = toRef(props, "hovered");
    const hoveredElement = ref(null);

    watch(hoveredStatus, (val) => {
      if (val) {
        hoveredElement.value.setDirection("forward");
        hoveredElement.value.play();
      } else {
        hoveredElement.value.setDirection("reverse");
        hoveredElement.value.play();
      }
    });

    return {
      hoveredStatus,
      hoveredElement,
    };
  },
  methods: {
    // stopLogo: function(){
    //     this.$refs.logo.stop();
    // },

    hoverLogo: function () {
      this.$refs["logo"].setDirection("forward");
      this.$refs["logo"].play();
    },

    leaveLogo: function () {
      this.$refs["logo"].setDirection("reverse");
      this.$refs["logo"].play();
    },
  },
};
</script>
